import React, {useEffect} from 'react'
import {useSolv} from "./components/SolvProvider"
import {useIntlEx} from "./components/IntlUtils.js"
import {closeDialog, ModalDialog} from "./components/DialogUtils";
import {ActionButton, Alert, useAlert} from "./components/FormComps";
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("ReinviteDialog")

export default function ReinviteDialog(props)  {

  const { api, setBusy} = useSolv()
  const {intl} = useIntlEx()
  const [alert, setAlert] = useAlert()

  async function handleReinviteClick() {

    // log.debug("handleInviteClick: 1")

    try {

      if (validate()) {

        setBusy(intl.msg("working"))

        const res = await api.reinviteMember(props.user.tenantId, props.user.userId)

        window.location.reload()

      }
      else {
        setAlert({type: "error", text: intl.msg("error_validation")})
      }
    }
    catch (error) {
      log.error("Validation error: ", error)
      handleError(error)
    }
    finally {
      setBusy(null)
    }
  }

  function validate() {
    return true
  }

  function handleError(error) {
    if (error && error.code) {
      // log.debug("handleError", error.code)
      const code = error.code
      const details = error.details
      switch (code) {
        case "BANNED_INVITER":
          setAlert({type: "error", text: intl.msg("error_banned_user", details)})
          break
        case "UNKNOWN_INVITER":
        case "INVALID_INVITER":
          setAlert({type: "error", text: intl.msg("invite_error_invalid_inviter", details), field: "inp_emailAddresses", constraint: "valid"})
          break
        case "DUPLICATE_INVITEE_USER":
          setAlert({type: "error", text: intl.msg("invite_error_duplicate_user", details), field: "inp_emailAddresses", constraint: "unique"})
          break
        case "DUPLICATE_INVITEE_TENANT":
          setAlert({type: "error", text: intl.msg("invite_error_duplicate_tenant", details), field: "inp_tenantName", constraint: "unique"})
          break
        case "DUPLICATE_INVITEE_REFERRAL_CODE":
          setAlert({type: "error", text: intl.msg("invite_error_duplicate_referral_code", details), field: "inp_referralCode", constraint: "unique"})
          break
        case "BANNED_EMAIL_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_banned_email_address", details), field: "inp_emailAddresses", constraint: "valid"})
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed", details)})
          break
      }
    }
    else {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  function handleOpenDialog() {
  }

  function handleCloseDialog() {
    closeDialog("dlg_reinvite")
  }

  function isOwner() {
    return (props?.user?.userLevel === 100)
  }

  useEffect(() => {
    log.debug(">>>Z: props=", props?.user?.emailAddress)
  }, [])

  return (

    <>
      <ModalDialog
        dialogId="dlg_reinvite"
        size="md"
        keyboard="true"
        backdrop="static"
        onOpen={handleOpenDialog}
        onClose={handleCloseDialog}>

        <ModalDialog.Header
          title={intl.msg(`${isOwner() ? "owner" : "member"}_reinvite_title`)}
          description={intl.msg(`${isOwner() ? "owner" : "member"}_reinvite_description`)}
          alert={alert}
        />

        <ModalDialog.Body>

          {
            !alert &&
              <Alert alert={{type: "warning", text: intl.msg("reinvite_text", {emailAddress: props.user?.emailAddress})}} align="center"/>
          }

        </ModalDialog.Body>

        <ModalDialog.Footer>
          <ModalDialog.Footer.Controls>
            <ActionButton name="reinvite" text={intl.msg("reinvite")} flavor="primary" disabled={!props.user?.emailAddress} onClick={handleReinviteClick}/>
            <ActionButton name="cancel" onClick={handleCloseDialog}/>
          </ModalDialog.Footer.Controls>
        </ModalDialog.Footer>

      </ModalDialog>

    </>
  )
}
